import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import Modal, { ModalProps } from '../../components/bakery/Modal'
import { Text } from 'rebass'
import { ButtonConfirmed } from '../../components/Button'

const ModalTitleStyle = styled.div`
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.1px;
  text-align: center;
`

const Image = styled.div`
  text-align: center;
  margin-top: 30px;
  margin-bottom: 10px;
`

const SubTitle = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 700;
`

const ButtonOk = styled(ButtonConfirmed)`
  width: 116px;
  height: 32px;
  margin: auto;
  margin-top: 30px
`

interface WinPrizeModal extends ModalProps {}

const WinPrizeModal: React.FC<WinPrizeModal> = ({
    onDismiss
}) => {
    const theme = useContext(ThemeContext)

    const closeModal = 
      () => {
        try {
          onDismiss && onDismiss()
        } catch (e) {
            console.log(e)
        }
    }
    
    return (
        <Modal maxWidth={406} backgroundColor={theme.bsBg1}>
          <ModalTitleStyle>What a pity</ModalTitleStyle>
          <Image>
            <img src="/images/nft/notwinprize.svg" alt=""/>
          </Image>
          <SubTitle>
            <Text fontSize={14} fontWeight={700} color={theme.bsText7}>You haven't got NFT</Text>
          </SubTitle>
          <ButtonOk onClick={closeModal}>
            OK
          </ButtonOk>
        </Modal >
    )
}
export default WinPrizeModal
